import { render, staticRenderFns } from "./ModalSlot.vue?vue&type=template&id=fd24f9d2&"
import script from "./ModalSlot.vue?vue&type=script&lang=js&"
export * from "./ModalSlot.vue?vue&type=script&lang=js&"
import style0 from "./ModalSlot.vue?vue&type=style&index=0&id=fd24f9d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports